import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useIndeedFlexShiftIssuesContextValue } from '../context/IndeedFlexShiftIssuesProvider'

export const IndeedFlexShiftIssuesHeader = () => {
  const { state, actions } = useIndeedFlexShiftIssuesContextValue()

  return (
    <Header
      title="Indeed Flex Shift Issues"
      rightContent={
        <QueryStatus
          dataUpdatedAt={state.dataUpdatedAt}
          isFetching={state.isFetching}
          refetch={actions.refetch}
          isError={state.isError}
          error={state.error}
        />
      }
    />
  )
}
